export default "__VITE_ASSET__zQ1NXen8__"